import {
  Box,
  Flex,
  Text,
  IconButton,
  Button,
  Stack,
  Collapse,
  Icon,
  Link,
  Popover,
  PopoverTrigger,
  PopoverContent,
  useColorModeValue,
  useBreakpointValue,
  useDisclosure,
  useColorMode,
} from "@chakra-ui/react";
import {
  HamburgerIcon,
  CloseIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  MoonIcon,
  SunIcon,
} from "@chakra-ui/icons";
import styled from "@emotion/styled";
import Logo from "../../assets/gadget.svg";
import { useEffect, useState } from "react";
import { Link as Linker } from "react-router-dom";
import { auth } from "../../firebaseConfig";
import { User } from "../../App";
import { useAtom } from "jotai";
import { useCookies } from "react-cookie";

export default function Navbar() {
  const { isOpen, onToggle } = useDisclosure();
  const { colorMode, toggleColorMode } = useColorMode();
  const [fixed, setFixed] = useState(false);
  const [isAuthenticated, setisAuthenticated]: any = useAtom(User);
  const [authUser, setUser] = useState<any>("");
  const [cookies, setCookie,removeCookie] = useCookies(["UserGad"]);
  useEffect(() => {
    auth.onAuthStateChanged((user: any) => {
      if (user) {
        setUser(user);
      } else {
        setUser("");
      }
    });
  }, []);


  useEffect(() => {
    if (authUser && authUser?.accessToken) {
      setisAuthenticated(authUser);
      setCookie("UserGad", authUser?.accessToken, {
        path: "/"
      });
    } else {
      setisAuthenticated("");
    }
  }, [authUser, authUser?.accessToken]);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setisAuthenticated("");
      removeCookie("UserGad")
      // Do something after the user logs out
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      if (scrollTop > 60) {
        // replace 100 with the desired scroll threshold
        setFixed(true);
      } else {
        setFixed(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <Box sx={{ position: "sticky", top: 0, zIndex: 10 }}>
      <Flex
        bg={useColorModeValue(fixed ? "white" : "#212F4A", "gray.800")}
        color={useColorModeValue("gray.600", "white")}
        minH={"60px"}
        py={{ base: 2 }}
        px={{ base: 4 }}
        borderBottom={fixed ? 1 : 0}
        borderStyle={"solid"}
        borderColor={useColorModeValue("gray.200", "gray.900")}
        align={"center"}
        // @ts-ignore
        position={fixed && "fixed"}
        w="100%"
        className="my-nav"
      >
        <Flex
          flex={{ base: 1, md: "auto" }}
          ml={{ base: -2 }}
          display={{ base: "flex", md: "none" }}
        >
          <IconButton
            onClick={onToggle}
            icon={
              isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
            }
            variant={"ghost"}
            aria-label={"Toggle Navigation"}
          />
        </Flex>
        <Flex flex={{ base: 1 }} justify={{ base: "center", md: "start" }}>
          <Linker to={"/"}>
            <Text
              textAlign={useBreakpointValue({ base: "center", md: "left" })}
              fontFamily={"heading"}
              color={useColorModeValue("gray.800", "white")}
            >
              <Div style={{ color: fixed ? "#000000" : "#FFF" }}>
                <img src={Logo} alt="" />
                GADGETING
              </Div>
              <Text
                className="desc-logo"
                style={{ color: fixed ? "#000000" : "#FFF" }}
              >
                Nayi Technology, Nayi Udaan
              </Text>
            </Text>
          </Linker>
          <Flex display={{ base: "none", md: "flex" }} ml={10}>
            <DesktopNav color={fixed} />
          </Flex>
        </Flex>

        <Stack
          flex={{ base: 1, md: 0 }}
          justify={"flex-end"}
          direction={"row"}
          spacing={6}
        >
          {isAuthenticated.accessToken && isAuthenticated.accessToken.length ? (
            <Button
              as={"a"}
              fontSize={"sm"}
              fontWeight={400}
              variant={"link"}
              href={"#"}
              color={"#ff5733"}
              // @ts-ignore
              variant={"outline"}
              display={{ base: "none", md: "inline-flex" }}
              onClick={handleLogout}
            >
              Log Out
            </Button>
          ) : (
            <>
              <Linker to={"login"}>
                <Button
                  as={"a"}
                  fontSize={"sm"}
                  fontWeight={400}
                  variant={"link"}
                  href={"#"}
                  color={"#ff5733"}
                  // @ts-ignore
                  variant={"outline"}
                  display={{ base: "none", md: "inline-flex" }}
                >
                  Sign In
                </Button>
              </Linker>
              <Button
                as={"a"}
                display={{ base: "none", md: "inline-flex" }}
                fontSize={"sm"}
                fontWeight={600}
                color={"white"}
                bg={"#ff5733"}
                href={"#"}
                _hover={{
                  bg: "#f04822",
                }}
              >
                Sign Up
              </Button>
            </>
          )}

          {/* <Button
            onClick={toggleColorMode}
            display={{ base: "none", md: "inline-flex" }}
          >
            {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
          </Button> */}
        </Stack>
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <MobileNav />
      </Collapse>
    </Box>
  );
}

const DesktopNav = ({ color }: any) => {
  const linkColor = useColorModeValue(color ? "gray.600" : "#FFF", "gray.200");
  const linkHoverColor = useColorModeValue("#ff5733", "white");
  const popoverContentBgColor = useColorModeValue("white", "gray.800");

  return (
    <Stack
      direction={"row"}
      spacing={4}
      justifyContent="center"
      alignItems={"center"}
    >
      {NAV_ITEMS.map((navItem) => (
        <Box key={navItem.label}>
          <Popover trigger={"hover"} placement={"bottom-start"}>
            <PopoverTrigger>
              <Linker to={navItem.href ?? "#"}>
                <Text
                  p={2}
                  fontSize={"sm"}
                  fontWeight={500}
                  color={linkColor}
                  _hover={{
                    textDecoration: "none",
                    color: linkHoverColor,
                  }}
                >
                  {navItem.label}
                </Text>
              </Linker>
            </PopoverTrigger>

            {navItem.children && (
              <PopoverContent
                border={0}
                boxShadow={"xl"}
                bg={popoverContentBgColor}
                p={4}
                rounded={"xl"}
                minW={"sm"}
              >
                <Stack>
                  {navItem.children.map((child) => (
                    <DesktopSubNav key={child.label} {...child} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
    </Stack>
  );
};

const DesktopSubNav = ({ label, href, subLabel }: NavItem) => {
  return (
    <Linker to={href}>
      <Link
        href={href}
        role={"group"}
        display={"block"}
        p={2}
        rounded={"md"}
        _hover={{ bg: useColorModeValue("pink.50", "gray.900") }}
      >
        <Stack direction={"row"} align={"center"}>
          <Box>
            <Text
              transition={"all .3s ease"}
              _groupHover={{ color: "#ff5733" }}
              fontWeight={500}
            >
              {label}
            </Text>
            <Text fontSize={"sm"}>{subLabel}</Text>
          </Box>
          <Flex
            transition={"all .3s ease"}
            transform={"translateX(-10px)"}
            opacity={0}
            _groupHover={{ opacity: "100%", transform: "translateX(0)" }}
            justify={"flex-end"}
            align={"center"}
            flex={1}
          >
            <Icon color={"#ff5733"} w={5} h={5} as={ChevronRightIcon} />
          </Flex>
        </Stack>
      </Link>
    </Linker>
  );
};

const MobileNav = () => {
  return (
    <Stack
      bg={useColorModeValue("white", "gray.800")}
      p={4}
      display={{ md: "none" }}
    >
      {NAV_ITEMS.map((navItem) => (
        <MobileNavItem key={navItem.label} {...navItem} />
      ))}
    </Stack>
  );
};

const MobileNavItem = ({ label, children, href }: NavItem) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Stack spacing={4} onClick={children && onToggle}>
      <Flex
        py={2}
        as={Link}
        href={href ?? "#"}
        justify={"space-between"}
        align={"center"}
        _hover={{
          textDecoration: "none",
        }}
      >
        <Text
          fontWeight={600}
          color={useColorModeValue("gray.600", "gray.200")}
        >
          {label}
        </Text>
        {children && (
          <Icon
            as={ChevronDownIcon}
            transition={"all .25s ease-in-out"}
            transform={isOpen ? "rotate(180deg)" : ""}
            w={6}
            h={6}
          />
        )}
      </Flex>

      <Collapse in={isOpen} animateOpacity style={{ marginTop: "0!important" }}>
        <Stack
          mt={2}
          pl={4}
          borderLeft={1}
          borderStyle={"solid"}
          borderColor={useColorModeValue("gray.200", "gray.700")}
          align={"start"}
        >
          {children &&
            children.map((child) => (
              <Link key={child.label} py={2} href={child.href}>
                {child.label}
              </Link>
            ))}
        </Stack>
      </Collapse>
    </Stack>
  );
};

interface NavItem {
  label: string;
  subLabel?: string;
  children?: Array<NavItem>;
  href?: any;
}

const NAV_ITEMS: Array<NavItem> = [
  {
    label: "Search",
    children: [
      {
        label: "Search New Gadgets",
        subLabel: "Buying your dream Gadget? Check Now!",
        href: "search",
      },
      {
        label: "Latest Gadgets",
        subLabel: "Know everything about the latest Gadgets",
        href: "latest-gadgets",
      },
    ],
  },
  {
    label: "Blog",
    href: "blog",
    // children: [
    //   {
    //     label: "Job Board",
    //     subLabel: "Find your dream design job",
    //     href: "#",
    //   },
    //   {
    //     label: "Freelance Projects",
    //     subLabel: "An exclusive list for contract work",
    //     href: "#",
    //   },
    // ],
  },
  {
    label: "EMI Calculator",
    href: "emi-calculator",
  },
  {
    label: "Services",
    href: "#",
  },
  {
    label: "About",
    href: "/about",
  },
  {
    label: "Contact",
    href: "/contact",
  },
];

const Div = styled.div`
  font-family: "Cabin", sans-serif;
  font-weight: 700;
  font-size: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 50px;
    height: auto;
  }
`;
